import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import useAxios from '../../hooks/useAxios';
import { FaRegAngry, FaRegFrown, FaRegMeh, FaRegSmile, FaRegGrinHearts } from 'react-icons/fa';

const SatisfactionModal = ({ show, onClose }) => {
    const [rating, setRating] = useState(null);
    const [hover, setHover] = useState(null);
    const [comment, setComment] = useState('');
    const [sent, setSent] = useState(false);

    const [{ loading }, sendSurvey] = useAxios({ url: '/surveys', method: 'POST' }, { manual: true });

    const faces = [
        { level: 1, icon: <FaRegAngry />, color: '#FF4D4D', label: 'Muy enojado' },
        { level: 2, icon: <FaRegFrown />, color: '#FF9F43', label: 'Enojado' },
        { level: 3, icon: <FaRegMeh />, color: '#B0BEC5', label: 'Normal' },
        { level: 4, icon: <FaRegSmile />, color: '#4CD137', label: 'Feliz' },
        { level: 5, icon: <FaRegGrinHearts />, color: '#009432', label: 'Muy feliz' }
    ];

    // --- LÓGICA DE VALIDACIÓN REFORZADA ---
    const isLowRating = rating && rating <= 3;
    const isCommentEmpty = !comment || comment.trim().length === 0;

    // El botón se bloquea si:
    // 1. No ha elegido carita (!rating)
    // 2. Se está enviando (loading)
    // 3. Es mala nota Y no escribió comentario (isLowRating && isCommentEmpty)
    const isButtonDisabled = !rating || loading || (isLowRating && isCommentEmpty);
    // -------------------------------------

    const handleSubmit = () => {
        // DOBLE CHEQUEO: Si está deshabilitado, detenemos todo aquí.
        if (isButtonDisabled) {
            console.log("Bloqueado: Falta comentario o calificación");
            return;
        }

        sendSurvey({ data: { rating, comment } }).then(() => {
            setSent(true);
            setTimeout(() => {
                handleClose();
            }, 2000);
        });
    };

    const handleClose = () => {
        setSent(false);
        setRating(null);
        setComment('');
        onClose();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            className="d-flex align-items-end ps-5 pb-4"
            style={{ paddingLeft: '270px' }}
            dialogClassName="m-0"
            contentClassName="border-0 rounded-4 shadow-lg"
        >
            <div className="position-absolute top-0 end-0 p-3" style={{ zIndex: 10 }}>
                <button onClick={handleClose} className="btn-close small" style={{ fontSize: '0.8rem' }}></button>
            </div>

            <Modal.Body className="text-center p-4">
                {!sent ? (
                    <div className="animate__animated animate__fadeIn">
                        <h5 className="mb-4 fw-bold text-dark"
                            style={{
                                lineHeight: '1.5',
                                paddingRight: '40px' // 👈 ESTO EMPUJA EL TEXTO PARA QUE NO TOQUE LA X
                            }}
                        >
                            ¿Qué tan fácil resulto gestionar tu pedido?
                        </h5>

                        <div className="d-flex justify-content-center align-items-start gap-3 mb-4">
                            {faces.map((face) => {
                                const isActive = rating === face.level;
                                const isHovered = hover === face.level;
                                return (
                                    <div
                                        key={face.level}
                                        className="d-flex flex-column align-items-center"
                                        style={{ width: '70px' }}
                                    >
                                        <div
                                            onMouseEnter={() => setHover(face.level)}
                                            onMouseLeave={() => setHover(null)}
                                            onClick={() => setRating(face.level)}
                                            className="d-flex align-items-center justify-content-center rounded-circle transition-all mb-2"
                                            style={{
                                                width: '55px', height: '55px', fontSize: '28px', cursor: 'pointer',
                                                backgroundColor: isActive || isHovered ? face.color : '#f1f2f6',
                                                color: isActive || isHovered ? 'white' : '#57606f',
                                                transform: isActive || isHovered ? 'scale(1.15)' : 'scale(1)',
                                                transition: 'all 0.2s ease',
                                                boxShadow: isActive ? `0 4px 10px ${face.color}66` : 'none'
                                            }}
                                        >
                                            {face.icon}
                                        </div>
                                        <span style={{ fontSize: '0.7rem', color: '#666', textAlign: 'center', lineHeight: '1.1', fontWeight: '500' }}>
                                            {face.label}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>

                        {/* CAMPO DE COMENTARIO */}
                        {isLowRating && (
                            <div className="animate__animated animate__fadeInUp mb-3">
                                <textarea
                                    className={`form-control bg-light ${isCommentEmpty ? 'border-danger' : 'border-0'}`}
                                    rows="2"
                                    placeholder="Tu opinión es muy importante..."
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    style={{ fontSize: '0.9rem', resize: 'none' }}
                                ></textarea>
                            </div>
                        )}

                        <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
                            <button className="btn btn-link text-secondary text-decoration-none fw-bold" onClick={handleClose} style={{ fontSize: '0.9rem' }}>
                                Saltar
                            </button>

                            {/* BOTÓN DINÁMICO */}
                            <Button
                                variant={!isButtonDisabled ? 'success' : 'secondary'}
                                onClick={handleSubmit}
                                disabled={isButtonDisabled}
                                className="px-4 fw-bold"
                                style={{ borderRadius: '8px', transition: 'all 0.3s' }}
                            >
                                {loading ? 'Enviando...' : (isLowRating && isCommentEmpty ? 'Escribe un comentario' : 'Siguiente')}
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div className="py-4 animate__animated animate__zoomIn">
                        <div className="mb-3 text-success" style={{ fontSize: '3rem' }}><FaRegGrinHearts /></div>
                        <h4 className="fw-bold text-dark">¡Gracias por tu respuesta!</h4>
                        <p className="text-muted mb-0">Nos ayudas a ser mejores.</p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default SatisfactionModal;